import React, { useState } from 'react';
import { products, productCategories } from '../data/mockData';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('extintores');

  const phoneNumber = '573184476101';

  const filteredProducts = products.filter(
    (product) => product.category === selectedCategory
  );

  const openWhatsApp = () => {
    const message = 'Hola, Quisiera tener información acerca de ...';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section id="productos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-block mb-4">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider bg-orange-100 px-4 py-2 rounded-full">
              Nuestros Productos
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Equipamiento de
            <span className="text-orange-600"> Primera Calidad</span>
          </h2>
          <p className="text-lg text-gray-600">
            Contamos con una amplia gama de productos para protección contra incendios.
          </p>
        </div>

        {/* Filtros */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {productCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all ${
                selectedCategory === category.id
                  ? 'bg-orange-600 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-orange-50 border-2 border-gray-200 hover:border-orange-300'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Descripción */}
        <div className="text-center mb-10">
          <p className="text-gray-600 text-lg">
            {productCategories.find((cat) => cat.id === selectedCategory)?.description}
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 group border border-gray-200"
            >
              {/* Imagen con fondo negro */}
              <div className="relative h-64 bg-black flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-500"
                />

                {/* Badge */}
                <div className="absolute top-4 right-4">
                  <Badge className="bg-orange-600 text-white border-0">
                    {product.certification}
                  </Badge>
                </div>
              </div>

              {/* Contenido */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                  {product.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {product.description}
                </p>

                {/* Specs */}
                <div className="space-y-2 mb-4">
                  {product.capacity && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Capacidad:</span>
                      <span className="font-medium text-gray-900">{product.capacity}</span>
                    </div>
                  )}
                  {product.fireTypes && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Clases:</span>
                      <span className="font-medium text-gray-900">{product.fireTypes}</span>
                    </div>
                  )}
                  {product.agent && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Agente:</span>
                      <span className="font-medium text-gray-900">{product.agent}</span>
                    </div>
                  )}
                </div>

                {/* Botón */}
                <Button
                  onClick={openWhatsApp}
                  className="w-full bg-orange-600 hover:bg-orange-700 text-white"
                >
                  Solicitar Información
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center border-2 border-orange-200">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            ¿No encuentras lo que buscas?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Tenemos acceso a un catálogo completo de productos. Contáctanos y te ayudaremos 
            a encontrar exactamente lo que necesitas para tu proyecto.
          </p>
          <Button
            onClick={openWhatsApp}
            size="lg"
            className="bg-orange-600 hover:bg-orange-700 text-white px-8"
          >
            Contactar con un Asesor
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Products;